// Facility configuration and metadata
export const FACILITY_TYPES = {
  HOURLY: 'hourly',
  DAILY: 'daily'
};

export const FACILITIES = {
  coworking1: {
    id: 'coworking-room-1',
    apiId: 1,
    name: 'コワーキングスペース - ルーム1',
    nameEn: 'Coworking Space - Room 1',
    shortName: 'コワーキング1',
    type: FACILITY_TYPES.HOURLY,
    icon: '💼',
    openTime: '05:00',
    closeTime: '23:00',
    category: 'work'
  },
  coworking2: {
    id: 'coworking-room-2',
    apiId: 2,
    name: 'コワーキングスペース - ルーム2',
    nameEn: 'Coworking Space - Room 2',
    shortName: 'コワーキング2',
    type: FACILITY_TYPES.HOURLY,
    icon: '💼',
    openTime: '05:00',
    closeTime: '23:00',
    category: 'work'
  },
  golfLounge: {
    id: 'golf-lounge',
    apiId: 6,
    name: 'ゴルフラウンジ',
    nameEn: 'Golf Lounge',
    shortName: 'ゴルフ',
    type: FACILITY_TYPES.HOURLY,
    icon: '⛳',
    openTime: '05:00',
    closeTime: '23:00',
    category: 'recreation'
  },
  bar: {
    id: 'bar',
    apiId: 7,
    name: 'バー',
    nameEn: 'BAR',
    shortName: 'BAR',
    type: FACILITY_TYPES.HOURLY,
    icon: '🍸',
    openTime: '16:00',
    closeTime: '22:00',
    category: 'dining'
  },
  executiveDining: {
    id: 'executive-dining',
    apiId: 8,
    name: 'エグゼクティブダイニングルーム',
    nameEn: 'Executive Dining Room',
    shortName: 'ダイニング',
    type: FACILITY_TYPES.HOURLY,
    icon: '🍽️',
    openTime: '10:00',
    closeTime: '22:00',
    category: 'dining',
    bookingDeadlineHours: 3 // 3 hours for dining
  },
  partyRoom: {
    id: 'party-room',
    apiId: 9,
    name: 'パーティルーム',
    nameEn: 'Party Room',
    shortName: 'パーティ',
    type: FACILITY_TYPES.HOURLY,
    icon: '🎉',
    openTime: '10:00',
    closeTime: '22:00',
    category: 'event',
    bookingDeadlineHours: 3 // 3 hours for party room
  },
  guestRoomLuz: {
    id: 'guestroom-luz',
    apiId: 10,
    name: 'Guestroom - LUZ',
    nameEn: 'Guestroom - LUZ',
    shortName: 'LUZ',
    type: FACILITY_TYPES.DAILY,
    icon: '🛏️',
    checkInTime: '15:00',
    checkOutTime: '10:00',
    category: 'accommodation'
  },
  guestRoomMadera: {
    id: 'guestroom-madera',
    apiId: 11,
    name: 'Guestroom - MADERA',
    nameEn: 'Guestroom - MADERA',
    shortName: 'MADERA',
    type: FACILITY_TYPES.DAILY,
    icon: '🛏️',
    checkInTime: '15:00',
    checkOutTime: '10:00',
    category: 'accommodation'
  }
};

// Get facilities by type
export const getFacilitiesByType = (type) => {
  return Object.values(FACILITIES).filter(facility => facility.type === type);
};

// Get facilities by category
export const getFacilitiesByCategory = (category) => {
  return Object.values(FACILITIES).filter(facility => facility.category === category);
};

// Get facility by ID
export const getFacilityById = (id) => {
  return Object.values(FACILITIES).find(facility => facility.id === id);
};

// Get facility by API ID
export const getFacilityByApiId = (apiId) => {
  return Object.values(FACILITIES).find(facility => facility.apiId === apiId);
};

// Check if facility is hourly-based
export const isHourlyFacility = (facilityId) => {
  const facility = getFacilityById(facilityId);
  return facility?.type === FACILITY_TYPES.HOURLY;
};

// Check if facility is day-based
export const isDailyFacility = (facilityId) => {
  const facility = getFacilityById(facilityId);
  return facility?.type === FACILITY_TYPES.DAILY;
};

// Format time for display
export const formatTime = (time) => {
  if (!time) return '';
  const [hours, minutes] = time.split(':');
  return `${hours}:${minutes}`;
};

// Convert 24-hour time to 12-hour format with AM/PM
export const formatTime12Hour = (time) => {
  if (!time) return '';
  const [hours, minutes] = time.split(':').map(Number);
  const period = hours >= 12 ? 'PM' : 'AM';
  const displayHours = hours === 0 ? 12 : hours > 12 ? hours - 12 : hours;
  return `${displayHours}:${minutes.toString().padStart(2, '0')} ${period}`;
};

// Get operating hours for a facility
export const getOperatingHours = (facilityId) => {
  const facility = getFacilityById(facilityId);
  if (!facility) return null;
  
  if (facility.type === FACILITY_TYPES.HOURLY) {
    return {
      open: facility.openTime,
      close: facility.closeTime,
      display: `${formatTime(facility.openTime)} - ${formatTime(facility.closeTime)}`
    };
  } else {
    return {
      checkIn: facility.checkInTime,
      checkOut: facility.checkOutTime,
      display: `Check-in: ${formatTime(facility.checkInTime)}, Check-out: ${formatTime(facility.checkOutTime)}`
    };
  }
};

// Get all facility IDs
export const getAllFacilityIds = () => {
  return Object.values(FACILITIES).map(facility => facility.id);
};

// Group facilities by category
export const groupFacilitiesByCategory = () => {
  const grouped = {};
  Object.values(FACILITIES).forEach(facility => {
    if (!grouped[facility.category]) {
      grouped[facility.category] = [];
    }
    grouped[facility.category].push(facility);
  });
  return grouped;
};